export default __webpack_public_path__ + "static/media/logo_chatdesk.7ebf392d.svg";